import React from 'react';
import { Route } from 'react-router';
import IFAuth from '../IFAuth';
import Status403Forbidden from '../Status403Forbidden';

export default function RouteAuth({ roleCodes = [], ...props }) {
    return (
        <IFAuth
            roleCodes={roleCodes}
            alt={Status403Forbidden({ roleCodes })}
        >
            <Route {...props} />
        </IFAuth>
    );
}
